<script>
export default {
  name: "UiCompletionLine",
  props: {
    is_completed: {
      type: Boolean,
      default: false,
    },
    is_required: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    bulletClasses() {
      if (this.is_required && !this.is_completed) {
        return "fa-exclamation-circle text-danger"
      }
      if (!this.is_completed) {
        return "fa-circle-thin text-gray-400"
      }
      return "fa-check-circle text-success"
    },
    labelClasses() {
      if (this.is_required && !this.is_completed) {
        return "text-danger"
      }
      if (!this.is_completed) {
        return null
      }
      return "text-muted"
    },
  },
}
</script>

<template>
  <li data-comp="UiCompletionLine" class="m-0">
    <i
      data-part="bullet"
      :class="[ 'fa fa-fw', bulletClasses]"
      aria-hidden="true"
    ></i>
    <span 
      data-part="label"
      :class="labelClasses"
    >
      <slot></slot>
    </span>
  </li>
</template>